import { Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatDate  } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalService } from '../services/global.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { TabsetConfig } from 'ngx-bootstrap/tabs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Constant } from '../../constant'

import * as $ from 'jquery';
import * as moment from 'moment';
export function getTabsetConfig(): TabsetConfig {
  return Object.assign(new TabsetConfig(), { type: 'pills' });
}
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [{ provide: TabsetConfig, useFactory: getTabsetConfig }]

})

export class DashboardComponent implements OnInit {
  public registerForm: FormGroup;
  public autopolicyno: any;
  public showmodal: boolean = false;
  public autodob: any;
  public paymentType: any;
  public originalPremiumAmt: 0;
  public submitted = false;
  public isValidAppno = false;
  public isValidAge = false;
  public isValidYear = false;
  public isstatus: any = '';
  public age: number;
  public finalDate;
  public Amount: any;
  public appl: any;
  public isError = false;
  public isErrorNewForm = false;
  public errorMessage: any;
  public showNewForm: boolean = false;
  public showOldForm : boolean = false;
  public showPolicyN : boolean = false;
  public showPolicyO : boolean = false;

  public showDateO : boolean= false;
  public showDateN : boolean = false;

  public showAmtN : boolean= false;
  public showAmtO  : boolean = false

  public showFreN : boolean = false;
  public showFreO : boolean = false;
  public newCustDate;
  modalRef: BsModalRef;
  modalRef1: BsModalRef;
  modalRef2: BsModalRef;
  modalRef3: BsModalRef;
  type:any;
  public userDatanewCustomer: any
  public userDataexistingCustomer: any
  public bsConfig;
  public bsConfig1;

  public temp: any;

  templateRef: any;
  isLimitCross: boolean = false;
  isExistingCustomer: boolean = false;
  hideExistingCustForm:boolean = false;
  nbComboSolnID:any;
  isInHouseApplNo:boolean = false ;
  retryPolicy:any;


  isDefenceAppln:boolean=false; // OPS-7166

  constructor(private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder, @Inject(LOCALE_ID)
    private locale: string,
    private router: Router,
    private service: GlobalService,
    private localStorageService: LocalStorageService,
    private toster: ToastrService,
    private modalService: BsModalService,
    private activatedRoute: ActivatedRoute
  ) {
   }

  ngOnInit() {
    this.localStorageService.clearAll(); 
    this.activatedRoute.queryParams
      .subscribe(params => {
        if(params.channel != '' && params.channel == 'agency'){
          this.localStorageService.set('channel',params.channel);
          this.getUniqueId();
        };
      } );
    this.showNewForm = true;
    this.showOldForm = true;
    this.showPolicyO = true;
    this.showDateO = true;
    this.showAmtO = true;
    this.showFreO = true;
// manual inputs
    this.showDateN = true;
    this.showAmtN = true;
    this.showFreN = true;

    this.loadJss();
    this.type="yes"
    this.autopolicyno = sessionStorage.getItem('p_policy_no_auto');
    this.autodob = sessionStorage.getItem('p_dob_auto');
    this.paymentType = sessionStorage.getItem('p_mandate_type');

    if(this.activatedRoute.snapshot.queryParams['retry_policy']){
      this.retryPolicy = this.activatedRoute.snapshot.queryParams['retry_policy'];
     if(this.retryPolicy)this.getRetryDataforExistingCustomer(this.retryPolicy);
     }
     if(this.activatedRoute.snapshot.queryParams['retry_unique_code']){
      let uniqueCode = this.activatedRoute.snapshot.queryParams['retry_unique_code'];
      if(uniqueCode) this.getUniqueId();
    }

    this.userDataexistingCustomer = {
      policyNumber: '',
      dateOfBirth: "",
      ischeckexis:''
    };
    this.registerForm = this.formBuilder.group({
      appno: ['', [Validators.required, Validators.maxLength(10)]],
      dob: ['', Validators.required],
      Amount: ['', [Validators.required]],
      frequency: ['', [Validators.required]],
      ischecked: ['', [Validators.required]]
    });
    this.userDatanewCustomer = {
      applicationNo: '',
      dateOfBirth: "",
      premiumAmount: '',
      frequency: '',
      ischecked:''
    };
    this.bsConfig = {
      containerClass: 'theme-green',
      isAnimated: true,
      dateInputFormat: 'dd-MM-yyyy'
    };
    this.bsConfig1 = {
      containerClass: 'theme-green',
      isAnimated: true,
      dateInputFormat: 'dd/MM/yyyy'
    };


  //  Sun Jan 08 1995 00:00:00 GMT+0530 (India Standard Time)
    // if(this.paymentType){
    //   if (this.paymentType === 'CCSI' || this.paymentType === 'ccsi') {
    //     this.showNewForm = false;
    //     this.showOldForm = false;
    //     this.type = 'CCSI';
    //     alert("CCSI facility is not available. Request to you please select another renewal preferred mode.");
    //     this.clearSession();
    //     return;
    //   }
    // }
    if (this.activatedRoute.snapshot.queryParams['appl_no']) {
      this.checkforgeneric();
    } else if (this.autopolicyno && this.autodob) {
      this.isExistingCustomer = true;
      this.userDataexistingCustomer.policyNumber = this.autopolicyno
      this.userDataexistingCustomer.dateOfBirth = this.autodob;
      this.spinner.show();
      this.submitAlredyExistingCustomersData();
    } else if (this.activatedRoute.snapshot.queryParams['autopay_mandate_type']) {
      let type = this.activatedRoute.snapshot.queryParams['autopay_mandate_type']
      if (type === 'CCSI' || type === 'ccsi') {
        // this.showNewForm = false;
        // this.showOldForm = false;
        // this.type = type;
        // alert("CCSI facility is not available. Request to you please select another renewal preferred mode.");
      } else {
        this.localStorageService.set('customerportal', this.activatedRoute.snapshot.queryParams['autopay_mandate_type']);
        this.showNewForm = false;
        var acc = document.getElementById('clickontwo').click();
        $('#paneltwo').css('max-height', '1500px');
      }
    }
  } // end ngonInit

  clearSession() {
    console.log("clear session")
    sessionStorage.removeItem('p_policy_no_auto');
    sessionStorage.removeItem('p_dob_auto');
    sessionStorage.removeItem('p_mandate_type');
    console.log("clear session")
  }
  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  loadJss() {

    var acc = document.getElementsByClassName("accordion");
    
    var i;
    
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }
  }
  closethePopup() {
    this.isErrorNewForm = false;
    this.isError = false;
  }
  submitNewCustomerData(template) {

    if (this.isValidAppno || this.isValidAge) {
      this.toster.error("Please fill the required fields!")
      return;
    }
    this.isErrorNewForm = false;
    this.localStorageService.set('Status', this.isstatus);

    if(this.userDatanewCustomer.dateOfBirth.length != 10){
      // const date1 = formatDate(this.userDatanewCustomer.dateOfBirth, this.bsConfig.dateInputFormat, this.locale);
      const date1 = moment(this.userDatanewCustomer.dateOfBirth, 'MM-DD-YYYY').format('DD-MM-YYYY');
      // const date1 = moment(this.userDatanewCustomer.dateOfBirth).format('DD/MM/YYYY');
      this.userDatanewCustomer.dateOfBirth = date1;
    }

     if (this.userDatanewCustomer.frequency.toString() === 'Monthly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
     // this.Amount = this.isInHouseApplNo?(this.Amount * 1.25):(this.Amount * 1.1);
     this.Amount = this.Amount * 1.50;  
    } else if (this.userDatanewCustomer.frequency.toString() === 'Quarterly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
    //  this.Amount = this.isInHouseApplNo?(this.Amount * 1.25):(this.Amount * 1.1);
    this.Amount = this.Amount * 1.50;  
    } else if (this.userDatanewCustomer.frequency.toString() === 'Half-Yearly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
     // this.Amount = this.isInHouseApplNo?(this.Amount * 1.25):(this.Amount * 1.1);
     this.Amount = this.Amount * 1.50;  
    } else if (this.userDatanewCustomer.frequency.toString() === 'Yearly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      //this.Amount = this.isInHouseApplNo?(this.Amount * 1.25):(this.Amount * 1.1);
      this.Amount = this.Amount * 1.50;  
    }
    let url = Constant.BaseUrl + Constant.setExistingCustomerData;

    if(this.isDefenceAppln){
      this.Amount = this.Amount * this.freq;
    }  // OPS-7166


    let reqObj = {
      "p_application_no": this.nbComboSolnID?this.nbComboSolnID:this.userDatanewCustomer.applicationNo,
      "p_unique_id": "",
      "p_dob": this.userDatanewCustomer.dateOfBirth,
      "p_prem_amount": this.Amount.toFixed(2),
      "p_frequency_value": this.userDatanewCustomer.frequency,
      "p_module": 'OPEN_LINK_NEW',
      "p_is_unique_code": 'NO'
    }
    this.spinner.show();
    this.service.PostService(url, reqObj).subscribe(response => {
      if (response.p_error_code === 'SUCCESS') {
        this.spinner.hide();

        let [day,month,year] = response.p_data.stringval3.split(/[-\/]/);
        let [day2,month2,year2] = response.p_data.stringval4.split(/[-\/]/);
 
        if(day === '29' && month === '02'){
          day = '28';
          response.p_data.stringval3 = `${day}-${month}-${year}`
        }
        if(day2 === '29' && month2 === '02'){
          day2 = '28';
          response.p_data.stringval4 = `${day2}-${month2}-${year2}`
        }
        
        this.localStorageService.set("userdata", response.p_data);
        this.localStorageService.set("FLAGFOREXISTING", response.p_data.stringval11);
        this.localStorageService.set("originalpremiumamt", this.userDatanewCustomer.premiumAmount);
        this.router.navigate(['/Customer']);
      }
      else {
        this.spinner.hide();
        this.modalRef = this.modalService.show(template, { class: 'modal-lg addcompmodal' });
        this.isErrorNewForm = true;
        this.errorMessage = response.p_message;
        this.userDataexistingCustomer.policyNumber = '';
        this.userDataexistingCustomer.dateOfBirth = '';
      }
    }, (error) => {
      this.spinner.hide();
    })
  }
  // submitNewCustomerData(template) {
  //   if (this.isValidAppno || this.isValidAge) {
  //     this.toster.error("Please fill the required fields!")
  //     return;
  //   }
  //   this.isErrorNewForm = false;
  //   this.localStorageService.set('Status', this.isstatus)
  //   console.log('Innnn');

  //   console.log(this.userDataexistingCustomer);

  //   const date1 = formatDate(this.userDataexistingCustomer.dateOfBirth, this.bsConfig.dateInputFormat, this.locale);

  //   this.userDatanewCustomer.dateOfBirth = date1;
  //   console.log("date1=="+date1);

  //   if (this.userDatanewCustomer.frequency.toString() === 'Monthly') {
  //     this.Amount = this.userDatanewCustomer.premiumAmount;
  //     this.Amount = (this.Amount * 1.1);

  //   } else if (this.userDatanewCustomer.frequency.toString() === 'Quarterly') {
  //     this.Amount = this.userDatanewCustomer.premiumAmount;
  //     this.Amount = (this.Amount * 1.1);

  //   } else if (this.userDatanewCustomer.frequency.toString() === 'Half-Yearly') {
  //     this.Amount = this.userDatanewCustomer.premiumAmount;
  //     this.Amount = (this.Amount * 1.1);

  //   } else if (this.userDatanewCustomer.frequency.toString() === 'Yearly') {
  //     this.Amount = this.userDatanewCustomer.premiumAmount;
  //     this.Amount = (this.Amount * 1.1);

  //   }
  //   let url = Constant.BaseUrl + Constant.setExistingCustomerData;
  //   console.log(this.userDatanewCustomer);

  //   console.log(this.userDatanewCustomer.dateOfBirth);

  //   if(this.date != ""){
  //     this.newCustDate = this.date;
  //   }else{
  //     this.newCustDate = this.userDatanewCustomer.dateOfBirth;
  //   }
  //   console.log(this.newCustDate);

  //   let reqObj = {
  //     "p_application_no": this.userDatanewCustomer.applicationNo,
  //     "p_unique_id": "",
  //     "p_dob": this.newCustDate,
  //     "p_prem_amount": this.Amount.toFixed(2),
  //     "p_frequency_value": this.userDatanewCustomer.frequency,
  //     "p_module": 'OPEN_LINK_NEW',
  //     "p_is_unique_code": 'NO'
  //   }
  //   this.spinner.show();
  //   this.service.PostService(url, reqObj).subscribe(response => {
  //     if (response.p_error_code === 'SUCCESS') {


  //       this.spinner.hide();
  //       this.localStorageService.set("userdata", response.p_data);
  //       this.localStorageService.set("originalpremiumamt", this.userDatanewCustomer.premiumAmount);
  //       this.localStorageService.set("mandateVal", this.Amount.toFixed(2));
  //       this.router.navigate(['/Customer']);
  //     }
  //     else {

  //       this.spinner.hide();
  //       this.modalRef = this.modalService.show(template, { class: 'modal-lg addcompmodal' });
  //       this.isErrorNewForm = true;
  //       this.errorMessage = response.p_message;
  //       this.userDataexistingCustomer.policyNumber = '';
  //       this.userDataexistingCustomer.dateOfBirth = '';
  //     }
  //   }, (error) => {
  //     this.spinner.hide();
  //   })
  // }

  onValueChange(value: Date): void {   //age calculation
    var date = new Date(this.userDatanewCustomer.dateOfBirth);

    this.userDatanewCustomer.dateOfBirth = value;
    if (this.userDatanewCustomer.dateOfBirth) {
      var timeDiff = Math.abs(Date.now() - new Date(this.userDatanewCustomer.dateOfBirth).getTime());
      this.age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
      if (this.age < 18) {
        this.isValidAge = true;
      }
      else {
        this.isValidAge = false;
      }
    }

  }

  onSelect(no) {
    if (no == 1) {
      this.isstatus = 'newCustomer';
      (<HTMLFormElement>document.getElementById("existingForm")).reset();
    }
    else if (no == 2) {

      this.isstatus = 'existingCustomer';
      // window.location.href ="https://la.bajajallianzlife.com/pre-login-services/auto-pay-registration";
      (<HTMLFormElement>document.getElementById("newForm")).reset();
      this.isValidAppno = false;
      this.isValidAge = false;
    }
  }


  submitexistingCustomerData(template, template1) {
    let temp = template;
    if (this.isValidAppno || this.isValidAge) {
      this.toster.error("Please fill the required fields!")
      return;
    }
    this.isError = false;
    this.localStorageService.set('Status', this.isstatus)
    if (this.userDataexistingCustomer.dateOfBirth) {
      // const date2 = formatDate(this.userDataexistingCustomer.dateOfBirth, this.bsConfig1.dateInputFormat, this.locale);
      const date2 = moment(this.userDataexistingCustomer.dateOfBirth, 'DD-MM-YYYY').format('DD-MM-YYYY');
      // const date2 = moment(this.userDataexistingCustomer.dateOfBirth).format('DD/MM/YYYY');


    this.finalDate = date2;
    }
    this.spinner.show();
    let url = Constant.BaseUrl + Constant.setNewCustomerData;


    let reqObj = {
      "p_application_no": this.userDataexistingCustomer.policyNumber,
      "p_dob": this.finalDate,
      "p_prem_amount": "",
      "p_frequency_value": "",
      "p_module": 'OPEN_LINK_EXISTING',
      "p_is_unique_code": 'NO'
    }
    this.service.PostService(url, reqObj).subscribe(response => {
      if (response.p_error_code === 'SUCCESS') {
        this.localStorageService.set("FLAGFOREXISTING", response.p_data.stringval11);
        this.localStorageService.set("setPSFFlag", response.p_data.stringval12);
        this.localStorageService.set("setGBOFlag", response.p_data.stringval13);
        this.getAllData(temp, template1);
        // this.spinner.hide();
      }
      else {
        this.errorMessage = response.p_message;
        this.modalRef = this.modalService.show(template, { class: 'modal-lg addcompmodal' });
        this.userDataexistingCustomer.policyNumber = '';
        this.userDataexistingCustomer.dateOfBirth = '';
        this.spinner.hide();
      }
    }, (error) => {
      this.spinner.hide();
    })
  }

  getAllData(template, template1) {

    this.showmodal = false;
    let url = Constant.BaseUrl + Constant.getAllData;
    let reqObj =
    {
      "p_policy_no": this.userDataexistingCustomer.policyNumber,
      "p_dob": this.finalDate,
      "p_email_id": "",
      "p_mobile_no": "",
      "p_application": "AUTO_PAY"
    }
    // this.spinner.show();
    this.service.PostService(url, reqObj).subscribe(response => {
      let data = [];
      if (response.p_error_code === 'SUCCESS') {
        data = response.p_pymnt_list;
        if (data) {
          data.forEach(element => {
            if (element.stringval30 == 'N') {

              this.spinner.hide();
              this.localStorageService.set("userdata", response.p_pymnt_list);
              this.localStorageService.set("mandateVal", parseFloat(response.stringval31).toFixed(2));

              this.modalRef1 = this.modalService.show(template1, { class: 'modal-sm addcompmodal' });
            }
            else if (element.stringval30 == 'Y') {
              this.localStorageService.set("userdata", response.p_pymnt_list);
              this.router.navigate(['/Customer']);
              this.spinner.hide();
            } else {
              this.spinner.hide();
            }
          });
        }
        else {
          this.spinner.hide();
          this.toster.error("Oops! Something went wrong. Please try again later.");
        }
      }
      else {
        this.spinner.hide();
        this.isError = true;
        this.errorMessage = response.p_message;
        this.modalRef = this.modalService.show(template, { class: 'modal-lg addcompmodal' });
      }
    }, (error) => {
      this.spinner.hide();
    })
  }
  confirm(): void {
    this.modalRef1.hide();
    this.spinner.show();
    this.router.navigate(['/Customer']);
    this.spinner.hide();

  }

  decline(): void {
    this.localStorageService.remove('userdata');
    //  this.router.navigate(['/dashboard']);
    this.modalRef1.hide();
  }

  onDateChange(newDate: Date) {
    // console.log(newDate);
  }

  checkApplicationno(event: any) {

    const pattern = /^[0-9]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^0-9]/g, "");
      // invalid character, prevent input
    }
    else {
      if (this.userDatanewCustomer.applicationNo.length !== 10 && this.userDatanewCustomer.applicationNo.length !== 0) {
        this.isValidAppno = true;
      } else if (this.userDatanewCustomer.applicationNo.length == 10 || this.userDatanewCustomer.applicationNo.length == 0) {
        this.isValidAppno = false;
      }
    }
  }

  nginFlag : string;
  date:any;
  newdate2:any;
  premium:any;
  freq:any;
  frequencyShow:any;
  routingInfoList:any = [];
  checkPolicy(event: any, template2,template3){
    this.appl = event.target.value;


    this.isDefenceAppln = false; // OPS-7166

    
    let url = Constant.BaseUrl + Constant.getFetchAutoData;
   let urlCheckPolicy = Constant.BaseUrl + Constant.checkPolicy;
    let reqObj = {
      "p_application_no":this.appl,
      "p_application":""
    }
    let reqObj1 = {
        "appln_number": this.appl,
    }
    this.spinner.show();
    this.service.PostService(urlCheckPolicy, reqObj1).subscribe(response => {

        if(response.statusCode == '200'){

           this.routingInfoList = response.routingInfoList[0];
            this.nginFlag = this.routingInfoList.target_system;
           if(this.routingInfoList.target_system == 'N'){
            this.spinner.hide();
                // NGIN policy
                this.modalRef2 = this.modalService.show(template2, { class: 'modal-md addcompmodal' });
           }else{

            // For OPUS policy
            this.service.PostService(url, reqObj).subscribe(response => {
              this.spinner.hide();
              if(response.ques_list.length == 0 || response.ques_list[0].stringval1 =="" && response.ques_list[0].stringval2 =="" &&
              response.ques_list[0].stringval3 ==""){
                this.modalRef3 = this.modalService.show(template3, { class: 'modal-md addcompmodal' });
                this.premium = "";
                this.newdate2 = "";
                this.frequencyShow = "";
              }
                if (response.ques_list.length  != 0) {
                  // this.showPolicyO = false;
                  // this.showPolicyN = true;
                  if(response.ques_list[0].stringval1 != ""){
                    this.premium = response.ques_list[0].stringval1;
                    this.showAmtO = false;
                    this.showAmtN = true;
                  }

                  if(response.ques_list[0].stringval10 != ""){
                    this.localStorageService.set("FLAG",response.ques_list[0].stringval10);
                   }

                  // else part is for manual inputs values
                  // else{
                  //   this.premium = response.ques_list[0].stringval1;
                  //   this.showAmtO = true;
                  //   this.showAmtN = false;
                  // }
                   if(response.ques_list[0].stringval2 != ""){
                    this.date = response.ques_list[0].stringval2;
                    this.newdate2 = moment(this.date, 'MM-DD-YYYY').format('DD-MM-YYYY');           
                    // this.newdate2 = formatDate(this.date, this.bsConfig.dateInputFormat, this.locale);
                    this.showDateO = false;
                    this.showDateN = true;
                  }
                  // else part is for manual inputs values
                  // else{
                  //   this.newdate2 = "";
                  //   this.showDateN = false;
                  //   this.showDateO = true;

                  // }
                   if( response.ques_list[0].stringval3 != ''){
                    this.freq = response.ques_list[0].stringval3;
                    this.showFreO = false;
                    this.showFreN = true;
                    if(this.freq == '1'){
                      this.frequencyShow = 'Yearly';
                    }else if(this.freq == '2'){
                      this.frequencyShow = 'Half-Yearly';
                    }else if(this.freq == '4'){
                      this.frequencyShow = 'Quarterly';
                    }else if(this.freq == '12'){
                      this.frequencyShow = 'Monthly';
                    }
                   }

                  //  if( response.ques_list[0].stringval4 != ''){
                  //   if(response.ques_list[0].stringval4.toLowerCase() == 'agency' || response.ques_list[0].stringval4.toLowerCase() == 'psf')
                  //   this.localStorageService.set('applnChannel', response.ques_list[0].stringval4.toLowerCase());
                  //  }

                   // else part is for manual inputs values
                  //  else{
                  //   this.frequencyShow = response.ques_list[0].stringval3;
                  //   this.showFreO = true;
                  //   this.showFreN = false;
                  //  }
                
                  // OPS-7166 starts
                  if( response.ques_list[0].stringval4 != ''){
                    if(response.ques_list[0].stringval4.toLowerCase() == 'agency' || response.ques_list[0].stringval4.toLowerCase() == 'psf'){
                      this.localStorageService.set('applnChannel', response.ques_list[0].stringval4.toLowerCase());
                    }else if (response.ques_list[0].stringval4.toLowerCase() == 'psf_defence') {
                      this.localStorageService.set('applnChannel', response.ques_list[0].stringval4.toLowerCase());
                      this.isDefenceAppln = true;
                    } 
                   }
                   //// OPS-7166 ends
                

                  if( response.ques_list[0].stringval5 != ''){
                    this.localStorageService.set('agentCode', response.ques_list[0].stringval5)                  
                  }

                  //for nb combo 
                  if(response.ques_list[0].stringval6 != ''){
                      this.nbComboSolnID = response.ques_list[0].stringval6;
                   }
                  if( response.ques_list[0].stringval7 != ''){
                    if(response.ques_list[0].stringval7 == 'IPPBBC' || response.ques_list[0].stringval7 == 'IPPB' || response.ques_list[0].stringval7 == 'IPPBC')
                    this.localStorageService.set('moduleFlag', response.ques_list[0].stringval7);
                   }

                   if( response.ques_list[0].stringval7 != ''){
                    if(response.ques_list[0].stringval7 == 'GBOWEB')
                    this.localStorageService.set('moduleFlag', response.ques_list[0].stringval7);
                   }

                  // check for inhouse application by agent code 3000000007
                  // response.ques_list[0].stringval5 = '3000000007';
                  if( response.ques_list[0].stringval5 != ''){
                    response.ques_list[0].stringval5 == '3000000007'? this.isInHouseApplNo = true :this.isInHouseApplNo = false  
                    this.localStorageService.set('agentCode', response.ques_list[0].stringval5)                  
                  }

                
                this.userDatanewCustomer = {
                   "applicationNo":this.appl,
                   'dateOfBirth': this.newdate2,
                   'premiumAmount': this.premium,
                   'frequency': this.frequencyShow
                };
             }
              else if (response.p_error_code === 'ERROR' || response.p_error_code !== 'SUCCESS') {

                this.errorMessage = response.p_message;
                this.toster.error(response.p_message);
              }
            }, (error) => {
              this.errorMessage = 'Oops! Something went wrong. Please try again later.';
              this.toster.error(this.errorMessage);
              this.spinner.hide();
            })
           }
        }
        else{
              this.errorMessage = 'Oops! Something went wrong. Please try again later.';
              this.toster.error(this.errorMessage);
              this.spinner.hide();
        }

   });

 }
 openNginModal(template2){
  this.modalRef2 = this.modalService.show(template2, { class: 'modal-md addcompmodal' });
 }
  proceedToNgin(){
    window.location.href = Constant.BaseUrl + Constant.nginUrl;
  }
  acceptOnlyNo(event: any) {
    const pattern = /^[0-9]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^0-9]/g, "");
    }
  }
  public CalculateAge(): void {
    var date = new Date(this.userDatanewCustomer.dateOfBirth);
    var year = date.getFullYear();
    var currentyear = (new Date()).getFullYear();
    if (this.userDatanewCustomer.dateOfBirth) {
      var timeDiff = Math.abs(Date.now() - new Date(this.userDatanewCustomer.dateOfBirth).getTime());
      this.age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
      if (this.age < 18) {
        this.isValidAge = true;
      }
      else {
        this.isValidAge = false;
      }
    }
  }

  onChangePolicyNo(event: any) {
    const pattern = /^[0-9]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^0-9]/g, "");
    }
    else {
      let policynolength = this.userDataexistingCustomer.policyNumber.length;

      if (policynolength < 10) {
        if (policynolength == 1) {
          this.temp = '000000000' + this.userDataexistingCustomer.policyNumber;
          this.userDataexistingCustomer.policyNumber = this.temp;
        }

        if (policynolength == 2) {
          this.temp = '00000000' + this.userDataexistingCustomer.policyNumber;
          this.userDataexistingCustomer.policyNumber = this.temp;
        }

        if (policynolength == 3) {
          this.temp = '0000000' + this.userDataexistingCustomer.policyNumber;
          this.userDataexistingCustomer.policyNumber = this.temp;
        }
        if (policynolength == 4) {
          this.temp = '000000' + this.userDataexistingCustomer.policyNumber;
          this.userDataexistingCustomer.policyNumber = this.temp;
        }
        if (policynolength == 5) {
          this.temp = '00000' + this.userDataexistingCustomer.policyNumber;
          this.userDataexistingCustomer.policyNumber = this.temp;
        }
        if (policynolength == 6) {
          this.temp = '0000' + this.userDataexistingCustomer.policyNumber;
          this.userDataexistingCustomer.policyNumber = this.temp;
        }
        if (policynolength == 7) {
          this.temp = '000' + this.userDataexistingCustomer.policyNumber;
          this.userDataexistingCustomer.policyNumber = this.temp;
        }
        if (policynolength == 8) {
          this.temp = '00' + this.userDataexistingCustomer.policyNumber;
          this.userDataexistingCustomer.policyNumber = this.temp;
        }
        if (policynolength == 9) {
          this.temp = '0' + this.userDataexistingCustomer.policyNumber;
          this.userDataexistingCustomer.policyNumber = this.temp;
        }
      }
      if (policynolength > 10) {
        this.userDataexistingCustomer.policyNumber = '';
      }
    }
  }


  submitAlredyExistingCustomersData() {   // for whatsup user.
    this.spinner.show();
    this.isError = false;
    this.localStorageService.set('Status', 'existingCustomer');
    let url = Constant.BaseUrl + Constant.setNewCustomerData;
    let reqObj = {
      "p_application_no": this.userDataexistingCustomer.policyNumber,
      "p_dob": this.userDataexistingCustomer.dateOfBirth,
      "p_prem_amount": "",
      "p_frequency_value": "",
      "p_module": 'OPEN_LINK_EXISTING',
      "p_is_unique_code": 'NO'
    }
    this.spinner.show();
    this.service.PostService(url, reqObj).subscribe(response => {
      if (response.p_error_code === 'SUCCESS') {
        this.localStorageService.set("FLAGFOREXISTING", response.p_data.stringval11);
        this.localStorageService.set("setPSFFlag", response.p_data.stringval12);
        this.localStorageService.set("setGBOFlag", response.p_data.stringval13);
        this.getAllDataforExistingCustomer();
      }
      else if (response.p_error_code === 'ERROR' || response.p_error_code !== 'SUCCESS') {
        this.showNewForm = false;
        this.showOldForm = false;
        this.errorMessage = response.p_message;
        this.toster.error(response.p_message);
        this.spinner.hide();
      }
    }, (error) => {
      this.errorMessage = 'Oops! Something went wrong. Please try again later.';
      this.toster.error(this.errorMessage);
      this.spinner.hide();
    })
  }
  getAllDataforExistingCustomer() {  // for whatsup user
    let url = Constant.BaseUrl + Constant.getAllData;
    let reqObj =
    {
      "p_policy_no": this.userDataexistingCustomer.policyNumber,
      "p_dob": this.userDataexistingCustomer.dateOfBirth,
      "p_email_id": "",
      "p_mobile_no": "",
      "p_application": "AUTO_PAY"
    }
    this.service.PostService(url, reqObj).subscribe(response => {
      let data = [];
      if (response.p_error_code === 'SUCCESS') {
        data = response.p_pymnt_list;
        if (data) {
          /* start Added by aishwarya on 04-11-2020*/
          this.localStorageService.set("userdata", response.p_pymnt_list);
          this.localStorageService.set('customerportal', this.paymentType);
          this.router.navigate(['/Customer']);
          setTimeout(() => {
            this.spinner.hide();
          }, 5000);
        }
        else {
          this.spinner.hide();
          this.toster.error("Oops! Something went wrong. Please try again later.");
        }
      }
      else {
        this.isError = true;
        this.showNewForm = false;
        this.showOldForm = false;
        this.errorMessage = response.p_message;
        this.toster.error(this.errorMessage);
        this.spinner.hide();
      }
    }, (error) => {
      this.errorMessage = 'Oops! Something went wrong. Please try again later.';
      this.toster.error(this.errorMessage);
      this.spinner.hide();
    })
  }

  checkforgeneric() {
    let id = this.activatedRoute.snapshot.queryParams['appl_no'];
    let payMode = this.activatedRoute.snapshot.queryParams['pay_mode'];
    let callbackURL = this.activatedRoute.snapshot.queryParams['callbackURL'];
    this.localStorageService.set("p_policy_no_auto", id);
    this.localStorageService.set("ren_pay_mode", payMode);
    this.localStorageService.set("callbackURL", callbackURL);
    this.router.navigate(['/genericLink']);
  }

  getUniqueId() {    
    let url = Constant.BaseUrl + Constant.getUniqueAppid;
    let reqObj =
    {
      "p_application": "OPEN_LINK"
    }
    this.spinner.show();
    this.service.PostService(url, reqObj).subscribe(response => {
      if (response.p_error_code === 'SUCCESS') {
        this.localStorageService.set('isInstab', true);
        this.localStorageService.set('uniqueid', response.p_unique_id);
        this.router.navigate(['/instabuser']);
      }
      else {
        alert(response.p_message);
      }
      setTimeout(() => {
        /** spinner ends after 3 seconds */
        this.spinner.hide();
      }, 3000);
    })
  }

  getRetryDataforExistingCustomer(policy_no:any){
    let url = Constant.BaseUrl + Constant.getAllData;
    let reqObj =
    {
      "p_policy_no": policy_no,
      "p_dob": "",
      "p_email_id": "",
      "p_mobile_no": "",
      "p_application": "AUTO_PAY"
    }
    this.service.PostService(url, reqObj).subscribe(response => {
      let data = [];
      if (response.p_error_code === 'SUCCESS') {
        data = response.p_pymnt_list;
        if (data) {
          /* start Added by aishwarya on 04-11-2020*/
          this.localStorageService.set("userdata", response.p_pymnt_list);
          this.localStorageService.set('Status', "existingCustomer")
          this.localStorageService.set('customerportal', this.paymentType);
          this.router.navigate(['/Customer']);
          setTimeout(() => {
            this.spinner.hide();
          }, 5000);
        }
        else {
          this.spinner.hide();
          this.toster.error("Oops! Something went wrong. Please try again later.");
        }
      }
      else {
        this.isError = true;
        this.showNewForm = false;
        this.showOldForm = false;
        this.errorMessage = response.p_message;
        this.toster.error(this.errorMessage);
        this.spinner.hide();
      }
    }, (error) => {
      this.errorMessage = 'Oops! Something went wrong. Please try again later.';
      this.toster.error(this.errorMessage);
      this.spinner.hide();
    })
  }
}

